var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.vm.isMobile)?_c('section',{staticClass:"free-time-section"},[_c('FreeTimeMobile'),(_vm.lang !== 'zh')?_c('FreeTimeSavingMobile'):_vm._e()],1):_c('FreeTimeForeignPC')}
var staticRenderFns = []

export { render, staticRenderFns }